var shop = {
    scrollAnimationOver: true,
    beforeScrollPositionY: 0,
    shopSmarkTab: null,
    bannerVideo: null,
    bannerSwiper: null,

    shopScrollEvent: function(){
        var _this = this;

        var t1 = $("#mall-notebook").offset() ? $("#mall-notebook").offset().top : 0;
        var t2 = $("#mall-workstation").offset() ? $("#mall-workstation").offset().top: 0;
        var t3 = $("#mall-server").offset() ? $("#mall-server").offset().top: 0;
        var t4 = $("#mall-computer").offset() ? $("#mall-computer").offset().top: 0;
        var t5 = $("#mall-internet").offset() ? $("#mall-internet").offset().top: 0;
        var t6 = $("#mall-storage").offset() ? $("#mall-storage").offset().top: 0;
        var t7 = $("mall-monitor").offset() ? $("#mall-monitor").offset().top: 0;

        var positionUpYs = [t1,t2,t3,t4,t5,t6,t7];

        var positionDownYs = [t7,t6,t5,t4,t3,t2,t1];
        //
        // positionUpYs =  positionUpYs.filter(function (item) {
        //     return item < 999999;
        // })
        //
        // positionDownYs =  positionDownYs.filter(function (item) {
        //     return item < 999999;
        // })

        window.onscroll = function () {


            if ($(".productList").offset().top + $(".productList").height() - 120 < document.scrollingElement.scrollTop ) {
                //当滚动高度大于6大分类底部120的时候显示吸顶tab栏

                if ($(".swiper-container-shoptab").hasClass('hide')){
                    $(".swiper-container-shoptab").removeClass('hide');
                    if ($(".swiper-container-shoptab").hasClass('swiper-container-shoptab-hide')){
                        $(".swiper-container-shoptab").removeClass('swiper-container-shoptab-hide');
                    }
                    $(".swiper-container-shoptab").addClass('swiper-container-shoptab-show');
                    if (!_this.shopSmarkTab){
                        _this.shopSmarkTab = new Swiper('.swiper-container-shoptab',{
                            freeMode: true,
                            slidesPerView: 'auto',
                            on:{
                                tap: function(event){
                                    // console.log(event,this,this.clickedIndex)
                                    var index = this.clickedIndex;
                                    _this.shopTabbbarSelChanged(index)
                                }
                            }
                        })
                    }
                }

                var scrollTop = $(this).scrollTop();
                var scrollHeight = $(document).height();
                var windowHeight = $(this).height();

                var beforePositionY =  _this.beforeScrollPositionY;
                _this.beforeScrollPositionY = document.scrollingElement.scrollTop;


                if (!_this.scrollAnimationOver){

                    if (document.scrollingElement.scrollTop - beforePositionY > 0) {

                        if (scrollHeight - windowHeight - 20 <= scrollTop) {
                            //到底了
                            _this.shopTabbbarSelChanged(positionUpYs.length - 1);
                            return;
                        }
                    }

                    return;
                }

                // console.log(scrollTop,scrollHeight,windowHeight,scrollHeight-windowHeight-20,scrollHeight-windowHeight-20 <= scrollTop);

                if (document.scrollingElement.scrollTop - beforePositionY > 0){
                    //向上滚动
                    if (scrollHeight-windowHeight-20 <= scrollTop){
                        //到底了
                        _this.shopTabbbarSelChanged(positionUpYs.length-1);
                        return;
                    }
                    positionUpYs.forEach(function (obj,index) {
                        if (document.scrollingElement.scrollTop + 130 > parseInt(obj) && parseInt(obj) != 0){
                            _this.shopTabbbarSelChanged(index);
                            return;
                        }
                    })

                } else{
                    //向下

                    positionDownYs.forEach(function (obj,index) {
                        if ( document.scrollingElement.scrollTop + 70 <= parseInt(obj)  && parseInt(obj) != 0){
                            _this.shopTabbbarSelChanged(positionDownYs.length - 1 - index);
                            return;
                        }
                    })
                }
            }else{
                //当滚动高度小于6大分类底部120的时候隐藏吸顶tab栏
                if (!$(".swiper-container-shoptab").hasClass('hide')){

                    if ($(".swiper-container-shoptab").hasClass('swiper-container-shoptab-show')){
                        $(".swiper-container-shoptab").removeClass('swiper-container-shoptab-show');
                    }

                    $(".swiper-container-shoptab").addClass('swiper-container-shoptab-hide');
                    setTimeout(function () {
                        $(".swiper-container-shoptab").addClass('hide');
                    },200)
                }

            }

        }
    },

    shopTabbbarSelChanged: function(index){
        // console.log($(".swiper-container-shoptab .swiper-slide").eq(index).attr('data-total'))
        if ($(".swiper-container-shoptab .swiper-slide").eq(index).attr('data-total') > 0){
            $('.swiper-container-shoptab .swiper-slide').removeClass(['swiper-slide-shoptab-sel','swiper-slide-active']);
            $(".swiper-container-shoptab .swiper-slide").eq(index).addClass(['swiper-slide-shoptab-sel','swiper-slide-active'])
        }
    },

    touchTabsNew: null,

    //新品速递tabbar
    initTabs: function(){
        var _this = this;
        var touchTabsNew = new TouchTabs('.tab-content-new', {
            seledClass:'new-seld', //选中后的css样式
            indicatorClass: '.new-indicator', //游标的样式
            dateAttribute:'data-page', //获取回传属性
            hookfunction: function(attr){
                var pagination = '.swiper-pagination-new-' + attr;
                attr = '.swiper-new-' + attr;
                $(".swiper-new").addClass('hide');
                $(attr).removeClass('hide');
                $('.swiper-pagination-new').addClass('hide');
                $(pagination).removeClass('hide');

                if (_this.touchTabsNew){
                    _this.touchTabsNew.destroy();
                    _this.touchTabsNew = null;
                }

                _this.touchTabsNew = new Swiper(attr, {
                    roundLengths: true,//防止模糊
                    speed: 300,//动画时间
                    pagination: {
                        el: pagination,
                    },
                    /*autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },*/
                })
            },
        });
        $('.new-seld').trigger("click");
    },

    // year-end
    initTabsYearEnd: function(){
        var _this = this;
        var touchTabsNew = new TouchTabs('.tab-content-year-end', {
            seledClass:'tab-item-active', //选中后的css样式
            indicatorClass: '.new-indicator', //游标的样式
            dateAttribute:'data-page', //获取回传属性
            hookfunction: function(attr){
                var pagination = '.swiper-pagination-new-' + attr;
                attr = '.swiper-new-' + attr;
                $(".swiper-new").addClass('hide');
                $(attr).removeClass('hide');
                $('.swiper-pagination-new').addClass('hide');
                $(pagination).removeClass('hide');

                if (_this.touchTabsNew){
                    _this.touchTabsNew.destroy();
                    _this.touchTabsNew = null;
                }

                _this.touchTabsNew = new Swiper(attr, {
                    roundLengths: true,//防止模糊
                    speed: 300,//动画时间
                    pagination: {
                        el: pagination,
                    },
                    /*autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },*/
                })
            },
        });
        $('.new-seld').trigger("click");
    },

    initShopSwiper: function () {

        new Swiper('.swiper-container-newtab',{
            freeMode: true,
            slidesPerView: 'auto',
        })

        this.bannerSwiper = new Swiper ('.swiper-container-banner', {
            // initialSlide :1,
            direction: 'horizontal', // 垂直切换选项
            slidesPerView: 'auto',
            centeredSlides: true,
            // loop: ($("#bannerNumber").val() > 1), // 循环模式选项
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper

            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },

            // 如果需要分页器
            pagination: {
                el: '.swiper-pagination-banner',
            },
            navigation: {
                nextEl: '.next-swiper-btn',
                prevEl: '.prev-swiper-btn',
            },
        });
        bannerVideo = document.getElementById('bannerVideo');
        this.bannerVideo = bannerVideo;
        var _this = this;
        $('.video-cover-image').on('click', function () {
            _this.bannerVideo.play();
        })

        this.bannerVideo.addEventListener('play',function () {
            console.log('video play');
            _this.bannerSwiper.autoplay.stop();
            $('.video-cover-image').hide();
            $('.bannerVideo').show();
        })
        this.bannerVideo.addEventListener('pause', function () {
            console.log('video pause');
            _this.bannerSwiper.autoplay.start();
            // $('.video-cover-image').show();
            // $('#bannerVideo').hide();
        })
        //商城首页分类
        var shopCatList = new Swiper ('.swiper-container-product-list', {
            slidesPerGroup: 3,
            // direction: 'horizontal', // 垂直切换选项
            slidesPerView: 'auto',
            // centeredSlides: false,
            loop: false, // 循环模式选项
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper

            // autoplay: {
            //     delay: 3000,
            //     disableOnInteraction: false,
            // },

            // 如果需要分页器
            scrollbar: {
                el: '.swiper-product-list-scrollbar',
                hide: false,
            },
        });


        var swiper_hotlist = new Swiper('.swiper-hot', {
            roundLengths: true,//防止模糊
            speed: 300,//动画时间
            effect: 'slide',//翻转方式/
            grabCursor: false,//是否开启抓手形状手
            slidesPerView: 2,//
            slidesPerGroup: 2,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'column',//排列方式
            spaceBetween: 1,
            pagination: {
                el: '.swiper-pagination-hot',
            },
            /*autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            }*/
        });

       // var newSwipers = ['.swiper-new-all','.swiper-new-notebook','.swiper-new-computer','.swiper-new-workstation','.swiper-new-server','.swiper-new-storage','.swiper-new-internet'];
       //
       // newSwipers.forEach(function (s,index) {
       //     var ss = s.split('-');
       //     // console.log('.swiper-pagination-new-'+ss[ss.length-1]);
       //     if (index == 0){
       //         var swipernew = new Swiper(s, {
       //             roundLengths: true,//防止模糊
       //             speed: 300,//动画时间
       //             observer:true,
       //             observeParents: true,
       //             // slidesPerView: 2,//
       //             // slidesPerGroup: 2,
       //             // slidesPerColumn: 2,
       //             // slidesPerColumnFill: 'row',//排列方式
       //             // spaceBetween: 1,
       //             pagination: {
       //                 el: '.swiper-pagination-new-'+ss[ss.length-1],
       //             },
       //             autoplay: {
       //                 delay: 3000,
       //                 disableOnInteraction: false,
       //             },
       //         });
       //     }
       //
       //      if (index > 0){
       //          $(s).addClass('hide');
       //      }
       // });
       // console.log(newSwiperObjs);

        var swiperContinarClasses = ['swiper-cate-list-notebook','swiper-cate-list-computer','swiper-cate-list-workstation','swiper-cate-list-server','swiper-cate-list-internet','swiper-cate-list-storage','swiper-cate-list-monitor'];
        var swiperIds = ['shopNotebook','shopComputer','shopWorkStation','shopServer','shopInternet','shopStorage','shopMonitor'];
        var swiperPaginations = ['swiper-pagination-notebook','swiper-pagination-computer','swiper-pagination-workstation','swiper-pagination-server','swiper-pagination-internet','swiper-pagination-storage','swiper-pagination-monitor'];
        for (var i = 0; i < 7; i++) {
            function createSwiper(cl,id,pag) {
                var s = new Swiper(cl, {
                    roundLengths: true,//防止模糊
                    grabCursor: false,//是否开启抓手形状手
                    // slidesPerView: 2.2  ,//
                    // freeMode: true,
                    on: {
                        /*reachEnd:function () {
                            shop.swiperReachEnd(id, this);
                        },*/
                        // slideChange: function(){
                        //     var activeSlide = this.activeIndex;
                        //     console.log('active index', activeSlide);
                        // },
                    },
                    slidesPerView: 2,//
                    slidesPerGroup: 2,
                    slidesPerColumn: 2,
                    slidesPerColumnFill: 'column',//排列方式
                    // spaceBetween: 1,
                    pagination: {
                        el: '.'+ pag,
                    },
                    /*autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    }*/
                });
            }
            createSwiper('.'+ swiperContinarClasses[i],swiperIds[i],swiperPaginations[i])
        }

        var sTwo = new Swiper('.swiper-cate-list-monitor-two', {
            roundLengths: true,//防止模糊
            grabCursor: false,//是否开启抓手形状手
            slidesPerView: 2,//
            slidesPerGroup: 2,
            // spaceBetween: 1,
            pagination: {
                el: '.swiper-pagination-monitor',
            },
        });
        var sTwostorage = new Swiper('.swiper-cate-list-storage-two', {
            roundLengths: true,//防止模糊
            grabCursor: false,//是否开启抓手形状手
            slidesPerView: 2,//
            slidesPerGroup: 2,
            // spaceBetween: 1,
            pagination: {
                el: '.swiper-pagination-storage',
            },
        });
        // 点击浮动导航
        $(".overscroll ul").on("click", "li", function () {
            var _inx = $(this).index();
            var _widt = $(this).width();
            var _ofleft = $(this)[0].offsetLeft;
            var _ofleftprev;
            if (_inx == 0) {
                _ofleftprev = 0;
            } else {
                _ofleftprev = $(this).prev()[0].offsetLeft;
            }
            $(this).siblings().removeClass("on");
            $(this).addClass("on");
            $(this).siblings(".onactive").stop().animate({
                width: _widt + "px",
                left: _ofleft + "px"
            }, 300)
            $(this).parents(".overscroll").animate({
                scrollLeft: _ofleftprev
            }, 300);
        })

        // 联系Dell
        $(".swiper-container").on("click", ".connectDell", function () {
            event.stopPropagation();
            //产品id
            var productId = $(this).attr("data-product-id");
            var productName = $(this).attr("data-product-name");

            // console.log("product-id",productId,"product-name",productName);
            //采购单链接
            nav.changeNav(event,'form', {
                'productname': productName,
                'productid': productId,
                'productNum': '',
                'productprice': '',
                'entrance': productName + '/' + productId
            })

            return false;

        })

        // 购买意向
        $(".swiper-container").on("click", ".shop-buy-button", function () {
            event.stopPropagation();
            //产品id
            var productId = $(this).attr("data-product-id");
            var productName = $(this).attr("data-product-name");
            var productSummary = $(this).attr("data-product-summary");
            var productSale =  $(this).attr("data-product-sale");
            var productPrice =  $(this).attr("data-product-price");
            var productCoverurl =  $(this).attr("data-product-coverurl");

            // console.log("product-id",productId,"product-name",productName);
            //采购单链接 onclick="nav.changeNav(event, 'form', {'productname':'name', 'productid':'id', 'entrance':'name/id'})"

            /*nav.changeNav(event,'form', {
                'productname': productName,
                'productid': productId,
                'productNum': '',
                'productprice': productPrice?productPrice:'',
                'entrance': productName + '/' + productId
            })*/

            shopDetailObj.openPurchaseDialog(
                productId,
                productName,
                productSummary,
                productSale,
                productPrice,
                productCoverurl,1);
            gio('track', 'ibuyClick')  //埋点实施方案


            // var linksourcemodule = '';
            // if(window.cateData.pageModule === 'industry'){
            //     linksourcemodule =  window.cateData.pageIndustryName;
            // }else{
            //     if(window.cateData.userRecodeOption.category2){
            //         linksourcemodule =  window.cateData.userRecodeOption.category2;
            //     }else if(window.cateData.userRecodeOption.category1) {
            //         linksourcemodule = window.cateData.userRecodeOption.category1;
            //     }else{
            //         linksourcemodule =  window.cateData.userRecodeOption.module;
            //     }
            // }
            //
            //     '&source=pop' +
            //     '&backUrl=' + encodeURIComponent(window.location.href) +
            //     '&productName=' + productName +
            //     '&productId=' + productId +
            //     '&productNum=1';

            return false;

        })

    },

    //{$pc_domain}/api/shop/{$cate_name}/wap/{$p}
    loadData: function(page,cate_name,callback){
        $.get(window.pcUrl+'/api/shop/'+cate_name+'/wap/'+page,{},function (data) {
            if (callback) {
                callback(data)
            };
        })
    },

    swiperReachEnd: function(docId, swiper){
        // console.log('swiper reach end',swiper)
        var doc = document.getElementById(docId)
        var currentPage = doc.dataset.currentPage;
        var totalPage = doc.dataset.totalPage;
        var cateName = doc.dataset.cateName;
        if (currentPage >= totalPage){
            return;
        }
        //如果当前页小于总页数
        //加载下一页数据
        shop.loadData(parseInt(currentPage)+1,cateName,function (data) {

            var slides = [];

            data.content.forEach(function (item) {
                // if (docId == 'shopHotProduct'){
                //     slides.push(shop.createHotHtml(item));
                // } else {
                    slides.push(shop.createCateHtml(item));
                // }
            })

            swiper.appendSlide(slides);
            if (parseInt(data.currentPage) > 2){
                swiper.slideNext();
            }
            doc.dataset.currentPage = data.currentPage;
        })

    },

    //热销机型  不再使用了
    createHotHtml: function(data){
        var coverurl = data.coverurl ? data.coverurl : '/static/mobile/images/productimgdef.png';
        return '<div class="swiper-slide">'+
            '<a href="'+data.url+'">'+
            '<div class="proName">'+ data.title+ '</div>'+
            '<div class="price">￥'+ data.price+ '</div>'+
            '<div class="hot-pro-buy-box shop-buy-button" data-product-id="'+data.id+'" data-product-name="'+ data.title +'">' +
            '<div class="hot-pro-buy"><span class="iconfont icon-shangcheng-copy"></span>项目咨询</div>'+
            '</div>'+
            '<div class="img">'+
            '<img src="'+coverurl+'" alt="">'+
            '</div>'+
            '</a>'+
            '</div>'
    },
    //新品速递 不再使用了
    createNewHtml: function(data){
        var coverurl = data.coverurl ? data.coverurl : '/static/mobile/images/productimgdef.png';

        return '<div class="swiper-slide">'+
            '<a href="'+data.url+'">' +
            '<div class="img">' +
            '<img src="'+coverurl+'" alt="">' +
            '</div>' +
            '<div class="proName">' + data.title +
            '</div>' +
            '<div class="price">￥'+data.price+'</div>' +
            '<div class="hopbotPBox shop-buy-button" data-product-id="'+data.id+'" data-product-name="'+ data.title +'">' +
            '<div class="hopbotP" data-src=""><span class="iconfont icon-shangcheng-copy">项目咨询</div>' +
            '</div>' +
            '</a>'+
            '</div>'
    },
    //分类商品
    createCateHtml: function(data){
        //图片
        var coverurl = data.coverurl ? data.coverurl : '/static/mobile/images/productimgdef.png';

        //价格
        var pricehtml = '';
        if (data.sale.length > 0){
            pricehtml = '<div class="price">'+data.sale+'<del>'+data.price+'</del></div>'
        }else if (data.price.length > 0){
            pricehtml = '<div class="price">'+data.price+'</div>'
        } else{
            pricehtml = '<div class="price connectDell" data-product-id="'+data.id+'" data-product-name="'+ data.title +'">联系戴尔</div>';
        }

        //爆款、新品 icon 图标
        var flagicon = '';
        if (data.signal && data.signal.length > 0){
            if (data.signal == 'new'){
                flagicon = '<img class="flag-icon" src="/static/mobile/images/mall/newflag_icon.png" alt="">\n'
            }else if (data.signal == 'hot'){
                flagicon = '<img class="flag-icon" src="/static/mobile/images/mall/hotflag_icon.png" alt="">\n'
            }
        }
        return '<div class="swiper-slide">'+
            '<a href="'+data.url+'">' +
            '<div class="img">' +
            flagicon +
            '<img src="'+coverurl+'" alt="">' +
            '</div>' +
            '<div class="proName">' + data.title +
            '</div>' +
            '<div class="proDesc">'+
            data.summary +
            '</div>' +
            pricehtml +
            '<div class="hopbotPBox shop-buy-button" data-product-id="'+data.id+'" data-product-name="'+ data.title +'" data-product-summary="'+ data.summary +'" data-product-sale="'+ data.sale +'" data-product-price="'+ data.price +'" data-product-coverurl="'+ data.coverurl +'">' +
            '<div class="hopbotP" data-src=""><span class="iconfont icon-shangcheng-copy"></span>项目咨询</div>' +
            '</div>' +
            '</a>'+
            '</div>'
    },

    //锚点跳转
    /*
    * totalPage 总页数 总页数为0时，提示“敬请期待”
    * poi 锚点
    * */
    toCategoryPosition: function(totalPage,poi){
        //如果是存储则跳到专题页
        // if(poi === 'mall-storage'){
        //     window.location.href = solution_m_host + /campaign/salesstorage';
        //     return;
        // }

        if (parseInt(totalPage) > 0){
            _this = this;
            _this.scrollAnimationOver = false;
            $('html, body').animate({scrollTop: document.getElementById(poi).offsetTop - 80}, 500, '', function () {
                _this.scrollAnimationOver = true;
            })

        }else{
            msg.toast("敬请期待");
        }
    },

    // 年末板块定位
    year_end_fixed: function(){
        $(function() {
            //获取定位参数
            var fixedNum = parseInt(getUrlPara('end_fixed'));
            //获取定位坐标
            setTimeout(function () {
                clickTab();
            }, 1000);

            function clickTab() {
                var fixedPos = document.querySelector('.tab-content-year-end').offsetTop - document.querySelector('.topbar').clientHeight * 2;

                console.log(fixedPos);

                if(!getUrlPara('end_fixed')){
                    return;
                }
                // document.documentElement.scrollTop = fixedPos;
                $('html, body').animate({scrollTop: fixedPos}, 800)

                switch (fixedNum) {
                    case 2:
                        document.querySelector('.tab-sales156998').click();
                        break;
                    case 3:
                        document.querySelector('.tab-sales156999').click();
                        break;
                    case 4:
                        document.querySelector('.tab-sales157000').click();
                        break;
                    default:
                        break;
                }
            }
        });
    },

    //页面加载完毕会调用此方法
    init: function () {
        this.initTabs();
        this.initShopSwiper();
        this.shopScrollEvent();

        // this.initTabsYearEnd();
        // this.year_end_fixed();
    }
};


